import { render, staticRenderFns } from "./PxSelecaoFornecedoresSelecionados.vue?vue&type=template&id=046ce601&"
import script from "./PxSelecaoFornecedoresSelecionados.vue?vue&type=script&lang=js&"
export * from "./PxSelecaoFornecedoresSelecionados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports